import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import {
    AuditActionEnum, IPostAuditAction
} from '.';
import { PostAuditAction, PostAuditSuccessAction, PostAuditFailedAction, } from './ActionCreator';
import { toast } from 'react-toastify';
import { AuditService } from '../../services/Audit.Service';
import { AuditEnum } from '../../services';

const auditService = new AuditService();

export const postAuditEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(AuditActionEnum.PostAudit),
    withLatestFrom(state$),
    switchMap(([action]: [IPostAuditAction]) => {
      if (action?.state?.auditLog) {

        const response = auditService.postAuditService(action.state.auditLog);
        return response;
      }
      else {
        return of(PostAuditFailedAction(AuditEnum.UnableToPostAudit));
      }
    }),
    map((response: boolean) => {
      return PostAuditSuccessAction();
    }),
    catchError((x) => {
      return of(PostAuditFailedAction(AuditEnum.UnableToPostAudit));
    })
  );
